import { growthFalloff, massToSize, sizeToMass } from '../formulas';
import type { Action, ActionContext } from './action';
import { consumePulses } from './action';

/**
 * GROW — each consumed click adds a fraction of current mass (so clicking is
 * proportional/compounding), but that fraction is scaled by a diminishing-
 * returns falloff that fades to 0 as size approaches the cap. Result: punchy
 * when small, a grind when big. Capped by the click-rate token bucket and the
 * world max size.
 */
export const growAction: Action = {
  id: 'grow',
  apply({ entity, cfg, dt }: ActionContext): void {
    const g = cfg.actions.grow;
    const used = consumePulses(entity, 'grow', dt, g.maxPerSec, g.burst);
    if (used <= 0) return;
    const gainFraction = g.massFractionPerPulse * used * growthFalloff(entity.size, cfg);
    const mass = sizeToMass(entity.size) * (1 + gainFraction);
    entity.size = Math.min(cfg.world.maxSize, massToSize(mass));
  },
};
